import { Link } from '@/components';
import ContentPreviewWraper from './ContentPreviewWraper';
import { ScrapbookFile } from '@/api';
import { TechLaunchDatabaseModel } from '@/types';
import TechLaunchDatabaseContent from '@/modules/TechLaunchDatabaseSearchModule/TechLaunchDatabaseContent';
import ArrowRight from '@/assets/arrowRightLight.svg';

type TechLaunchDatabasePreviewProps = {
  content: ScrapbookFile | null;
  onClose: () => void;
};

const TechLaunchDatabasePreview = ({ content: file, onClose }: TechLaunchDatabasePreviewProps) => {
  const content = file?.content as TechLaunchDatabaseModel;
  /*
  const download = () => {
    // TODO: implement download logic
  };
*/
  return (
    <ContentPreviewWraper
      content={file}
      onClose={onClose}
      title="Tech Launches Database"
      subTitle={content?.title}
      //onDownload={download}
      footerContent={
        content?.link && (
          <Link
            link={content.link}
            className="v-btn view-btn float-right mr-4 flex min-h-[44px] items-center rounded-4xl border border-black/20 px-7 py-2 !font-semibold tracking-[1.25px] !text-black/80 hover:bg-black/5"
          >
            <div>View Details</div>
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        )
      }
    >
      <div className="flex h-full flex-col">
        <TechLaunchDatabaseContent data={content!} hideSaveToScrapbook />
      </div>
    </ContentPreviewWraper>
  );
};

export default TechLaunchDatabasePreview;
